import { Component, input } from '@angular/core';
import { IconComponent } from '@outlaw/icons';
import type { IconName } from '@outlaw/icons';

@Component({
  selector: 'outlaw-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.scss'],
  imports: [IconComponent],
})
export class EmptyStateComponent {
  icon = input.required<IconName>();
  label = input.required<string>();
}
